/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/associatedDevicesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a AssociatedDevices. */
export class AssociatedDevices {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a AssociatedDevices.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Device Manager to return associated devices.
   * @summary Retrieves list of associated devices registered for the user.
   * @param [options] The optional parameters
   * @returns Promise<Models.AssociatedDevicesGetAssociatedDevicesResponse>
   */
  getAssociatedDevices(options?: Models.AssociatedDevicesGetAssociatedDevicesOptionalParams): Promise<Models.AssociatedDevicesGetAssociatedDevicesResponse>;
  /**
   * @param callback The callback
   */
  getAssociatedDevices(callback: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAssociatedDevices(options: Models.AssociatedDevicesGetAssociatedDevicesOptionalParams, callback: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): void;
  getAssociatedDevices(options?: Models.AssociatedDevicesGetAssociatedDevicesOptionalParams | coreHttp.ServiceCallback<Models.AssociatedDevice[]>, callback?: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): Promise<Models.AssociatedDevicesGetAssociatedDevicesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAssociatedDevicesOperationSpec,
      callback) as Promise<Models.AssociatedDevicesGetAssociatedDevicesResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to return all asspciated devices from DDS.
   * @summary Retrieves all associated devices from DDS for testing purposes.
   * @param [options] The optional parameters
   * @returns Promise<Models.AssociatedDevicesGetAllAssociatedDevicesResponse>
   */
  getAllAssociatedDevices(options?: Models.AssociatedDevicesGetAllAssociatedDevicesOptionalParams): Promise<Models.AssociatedDevicesGetAllAssociatedDevicesResponse>;
  /**
   * @param callback The callback
   */
  getAllAssociatedDevices(callback: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAllAssociatedDevices(options: Models.AssociatedDevicesGetAllAssociatedDevicesOptionalParams, callback: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): void;
  getAllAssociatedDevices(options?: Models.AssociatedDevicesGetAllAssociatedDevicesOptionalParams | coreHttp.ServiceCallback<Models.AssociatedDevice[]>, callback?: coreHttp.ServiceCallback<Models.AssociatedDevice[]>): Promise<Models.AssociatedDevicesGetAllAssociatedDevicesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllAssociatedDevicesOperationSpec,
      callback) as Promise<Models.AssociatedDevicesGetAllAssociatedDevicesResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAssociatedDevicesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/AssociatedDevices",
  queryParameters: [
    Parameters.includeFamilyDevices
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedDevice"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAllAssociatedDevicesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/AssociatedDevices/raw",
  queryParameters: [
    Parameters.includeFamilyDevices
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedDevice"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
